import { useCallback, useState } from "react";

export default function useThrowAsyncError() {
    const [, setState] = useState();

    return useCallback((error: unknown) => {
        setState(() => {
            throw error instanceof Error ? error : new Error(String(error));
        });
    }, []);
}
